<template>
  <modal v-if="isOpen" class-name="days-info-modal" @close="$emit('close')">
    <template #body>
      <div>
        <h1 class="page-headline">
          14 Tage Rückgaberecht
        </h1>
        <p>
            Wir möchten Ihnen die Möglichkeit geben, Ihr neues Fahrzeug genau kennenzulernen. Sollten Sie feststellen, dass Sie nicht vollständig zufrieden sind, können Sie, gemäß §13 BGB als natürliche Person, innerhalb von 14 Tagen nach Entgegennahme Ihres Autos vom Widerrufsrecht Gebrauch machen.
            <br>
            <br>
            Nach Rückerhalt des Fahrzeugs im vergleichbaren Zustand wie bei der Auslieferung, veranlassen wir die Rückzahlung auf das Konto, über welches wir die Zahlung von Ihnen erhalten haben. Wir behalten uns vor, zurückgegebene Fahrzeuge mit einer Nutzung von mehr als 100 km gesondert auf Wertverlust zu prüfen. Wir unterstützen Sie bei der Rückgabe des Autos und tragen die Kosten für den Rücktransport.
            <br>
            <br>
            <b>Weitere Informationen zum Widerrufsrecht finden Sie unter §3 unserer <a href="https://www.pkw.de/agb/nutzer/" title="mehr erfahren" target="_blank">AGB</a>.</b>
            <br>
            <br>
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};
</script>
<style lang="scss">
    .days-info-modal {
        .page-headline {
            font-family: "Asap", sans-serif;
            color: #131313;
            font-size: 16px;
            font-weight: 600;
            margin-bottom:20px;
        }
        p {
            font-family: "Asap", sans-serif;
            color: #131313;
            font-size: 16px;
            font-weight: normal;
            line-height: 21px;
        }

        a {
          color: $red;
        }
    }
</style>
